import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import "../analytics";
import { PATH_TO_TEACHER_ASSIGNMENTS_STATE } from "./consts";
import TeacherAssignment, {
  TeacherAssignmentType
} from "./models/TeacherAssignment";
import teacherAssignmentsReducer from "./reducers/state";

ReducerRegistry.getInstance().initialise(
  PATH_TO_TEACHER_ASSIGNMENTS_STATE,
  builder => {
    builder.register(
      PATH_TO_TEACHER_ASSIGNMENTS_STATE,
      teacherAssignmentsReducer
    );
  }
);

// reducers
export { PATH_TO_TEACHER_ASSIGNMENTS_STATE };
export { teacherAssignmentsReducer };

// models
export { TeacherAssignment };
export type { TeacherAssignmentType };
export type { TeacherAssignmentsStateType } from "./models/TeacherAssignmentsState";
export { default as TeacherAssignmentsState } from "./models/TeacherAssignmentsState";

export { AssigneeStatuses } from "./selectors/state/assignments/assignment/assignees/consts";

export type { EmbeddedAnswerMark } from "./models/Assignee/QuestionStat";

// actions
export {
  receiveAssignment,
  receiveAssignments,
  deleteAssignment
} from "./actions";
export {
  fetchCurrentClassAssignmentsActionFactory,
  fetchAllClassAssignmentsActionFactory,
  createAssignmentActionFactory,
  deleteAssignmentActionFactory,
  updateAssignmentActionFactory,
  fetchAssignmentActionFactory
} from "./actions/meta";

// selectors
export {
  getStateAssignments,
  getAssignment,
  getAssignmentSectionLastSetDate,
  getAssignmentStartDate,
  getAssignmentDueDate,
  getAssignmentName,
  getAssignmentCourseId,
  getAssignmentSectionIds,
  getAssignmentExamQuestionIds,
  getAssignmentNumberOfSections,
  getAssignmentNumberOfExamQuestions,
  getAssignmentCutoffDate,
  getAssignmentAssignees,
  getAssignmentSpecType,
  getAssignmentIsSmart,
  getAssignmentNumberOfAssignees,
  getHasNoAssignees,
  getIsPastAssignment,
  makeGetClassAssignmentIds,
  assignmentExists,
  getAutoEnrolNewStudents,
  makeGetNumberOfClassAssignments,
  makeGetNumberOfUpcomingClassAssignments,
  makeGetNumberOfPastClassAssignments,
  getAssignmentAssigneesWithSections,
  getIsAssignmentAfterCutoffDate,
  getAssignmentSectionAverageScore,
  getNumberOfAssigneesWithStatus,
  getAssignees,
  getAssigneeSectionStats,
  getAssigneeStatus,
  getAssigneeAggregatedStats,
  getAssigneeTotalStudyTime,
  getAssigneeAverageScore,
  getAssigneeSectionIds,
  isAssignmentWithStats,
  getIsAfterAssignmentDueDate,
  getSmartAssignmentSectionsFromConditions,
  getAssignee,
  getAssigneeQuestionStats,
  assignmentIncludesExamQuestions,
  assignmentHasNoSections,
  getAssigneeIndividualQuestionStats,
  getAssignmentQuestionsAverageMark,
  getAssignmentQuestionsMarksTotal,
  getAssignmentQuestionAverageMark,
  getAssignmentQuestionMarksTotal,
  getAssigneeQuestionTeacherMark,
  getAssigneeQuestionEmbeddedAnswerMarks,
  getAssigneeQuestionAutoMark,
  getAssigneeQuestionSelfMark,
  getAssigneeQuestionTotalMarks,
  makeGetNumberOfAnswersNeedMarking,
  makeGetNumberOfAnswersNotRemarked,
  getAssigneeQuestionFlagged,
  getAssigneeQuestionNeedsMarking,
  getNumberOfStudentsNeedMarking,
  getNumberOfAssigneesInProgress,
  getAssigneeQuestionConfidence
} from "./selectors";

// meta selectors
export {
  // fetch future class assignments
  classAssignmentsAreFetching,
  classAssignmentsFetchSucceeded,
  classAssignmentsFetchErrored,
  classAssignmentsFetchFinished,
  classAssignmentsNeedFetching,
  makeSelectorWithClassAssignmentFetchSucceeded,
  //fetch all assignments
  allClassAssignmentsAreFetching,
  allClassAssignmentsFetchSucceeded,
  allClassAssignmentsFetchErrored,
  allClassAssignmentsFetchFinished,
  allClassAssignmentsNeedFetching,
  makeSelectorWithAllClassAssignmentFetchSucceeded,
  // create
  assignmentIsBeingCreated,
  assignmentCreateSucceeded,
  assignmentCreateErrored,
  getAssignmentCreateErrorMessage,
  // update
  assignmentIsBeingUpdated,
  assignmentUpdateSucceeded,
  assignmentUpdateErrored,
  getAssignmentUpdateErrorMessage,
  // delete
  assignmentIsBeingDeleted,
  assignmentDeleteSucceeded,
  assignmentDeleteErrored,
  //fetch existing assignment
  classAssignmentIsFetching,
  classAssignmentFetchSucceeded,
  classAssignmentFetchErrored,
  classAssignmentFetchFinished,
  classAssignmentNeedsFetching
} from "./selectors/meta";
